import { TFunction } from 'i18next';
import moment from 'moment';

export const getMomentOfChange = (date: Date, t: TFunction): string => {
  const dateMoment = moment(date);
  const days = moment().startOf('day').diff(dateMoment.startOf('day'), 'days');
  const hour = moment(new Date(date), 'HH:mm').format('LT');
  const dateFormatted = dateMoment.format('L');

  switch (days) {
    case 0:
      return t('todayAtXHour', { hour });
    case 1:
      return t('yesterdayAtXHour', { hour });
    default:
      return t('onXDateAtYHour', { hour, dateFormatted });
  }
};
